
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/antd-design-x.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-guide-antd-design-x-demo-0","docs-guide-antd-design-x-demo-1"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/antd-design-x.md?type=demo')
};